import { BexApiStore, ClientOptions } from 'bernie-graphql';
import { SerializedData } from 'bernie-core';
import { ContextInput } from 'bernie-context';
import { Request } from 'bernie-http';
import { Logger, NOOP_LOGGER } from 'bernie-logger';
import { action } from 'mobx';

import { ApiOperations } from 'common/__generated__/api';

export class CarsStore extends BexApiStore {
  private appConfig: any;
  private timer;
  private static resultsExpirationTime = 30000 * 60;
  public isApp: boolean;

  constructor(
    bexConfigs: ClientOptions,
    logger: Logger = NOOP_LOGGER,
    appConfig: SerializedData,
    requestOrContext: ContextInput | Request
  ) {
    const headers = CarsStore.getRequestHeaders(requestOrContext);
    super(ApiOperations.withClient, bexConfigs, logger, headers);
    this.appConfig = appConfig;
    this.timer = null;
    this.isApp = CarsStore.getIsApp(requestOrContext);
  }

  public hydrate(data: SerializedData) {
    super.hydrate(data);
    this.appConfig = { ...data.appConfig };
    this.bexApiSource.clientConfigs.bexApiUrl = this.appConfig.graphqlURL;
  }

  @action
  public startResultsExpirationTimer(handler: () => void) {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      handler();
    }, CarsStore.resultsExpirationTime);
  }

  @action
  public addDomainRedirectHeader(headers, domainServiceRedirect): Headers {
    let clientInfoHeader = headers['client-info'];
    if (clientInfoHeader) {
      clientInfoHeader = clientInfoHeader + ',domain-redirect:' + domainServiceRedirect;
    } else {
      clientInfoHeader = 'domain-redirect:' + domainServiceRedirect;
    }

    return {
      ...headers,
      'client-info' : clientInfoHeader
    };
  }

  private static getIsApp = (param: any) => {
    if (param.context) {
      const requestParam: Request = param;
      const userAgent = requestParam.headers['user-agent'];
      if (userAgent) {
        const userAgentLowerCase = userAgent.toLowerCase();
        if (userAgentLowerCase.includes('app.webview')) {
          // request is from web view
          return (
            userAgentLowerCase.includes('android') ||
            userAgentLowerCase.includes('iphone') ||
            userAgentLowerCase.includes('ipad')
          );
        }
      }
    }

    return false;
  };

  private static getRequestHeaders = (param: any) => {
    let headers = {};
    if (!param) {
      return headers;
    }
    if (param.context) {
      const requestParam: Request = param;
      headers = {
        'Device-User-Agent-ID' : requestParam.context.deviceId,
        'Client-Info'          : 'playground,none,localhost'
      };
    } else if (param.identity) {
      const bexApiContext: ContextInput = param;
      headers = {
        'Device-User-Agent-ID' : bexApiContext.identity.duaid
      };
    }

    return headers;
  };
}
